import { render, staticRenderFns } from "./order-chat.vue?vue&type=template&id=739b94b7"
import script from "./order-chat.vue?vue&type=script&lang=js"
export * from "./order-chat.vue?vue&type=script&lang=js"
import style0 from "./order-chat.vue?vue&type=style&index=0&id=739b94b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports